






















import Vue from "vue";
import { Component, Watch, Emit, Prop } from "vue-property-decorator";
import './simplemodal.less';


@Component({
  components: {
  }
})
export default class Simplemodal extends Vue {
    @Prop() modal_title ;
    @Prop() modal_content;
    @Prop() modal_id ;

  mounted() {
    
  }


}
